import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import "./LandingBoxNav.css"
import PopupNotif from "../PopupNotif/PopupNotif";
// import { marketPulseEnabled } from "../../../utils/configs";

export type BoxTypes = "haw" | "vmpd" | "bmn" | "rfr";

interface BoxParams {
    heading: string;
    link: string;
    content: string;
    icon: JSX.Element;
    notif?: JSX.Element | null;
    notifStatic?: JSX.Element | null;
}

interface LandingBoxNavProps {
    boxType: BoxTypes;
}

export default function LandingBoxNav(props: LandingBoxNavProps): JSX.Element {

    const { t } = useTranslation("landing");

    const boxes: Record<BoxTypes, BoxParams> = {
        haw: {
            heading: t("landing.haw"),
            link: "/amp/property-assessment",
            content: t("landing.home.haw-bubble-content"),
            icon: <img src="images/HowMyPropertyAssessed.png" alt=""></img>
        },
        vmpd: {
            heading: t("landing.vmpd"),
            link: "/amp/property",
            content: t("landing.home.vmpd-bubble-content"),
            icon: <img src="images/ViewPropertyDetails.png" alt=""></img>,
            // notif: marketPulseEnabled ? <div className="notif-top">{t("landing.home.vmpd-notif")}</div> : null
        },
        bmn: {
            heading: t("landing.nbhd"),
            link: "/amp/nbhd",
            content: t("landing.home.bmn-bubble-content"),
            icon: <img src="images/BrowseNeighbourhood.png" alt=""></img>,
            //notif: marketPulseEnabled ? (<div className="notif-top"><img src="images/PropertyPulseDashWhite.png" alt=""/>{t("landing.home.bmn-notif")}</div>) : null
            //notifStatic: marketPulseEnabled ? (<div className="notif-top notif-static"><img src="images/PropertyPulseDashWhite.png" alt=""/>{t("landing.home.bmn-notif")}</div>) : null
        },
        rfr: {
            heading: t("landing.rfr"),
            link: "/amp/rfr",
            content: t("landing.home.rfr-bubble-content"),
            icon: <img src="images/FileRfR.png" alt=""></img>
        }
    }

    const boxDetails = boxes[props.boxType];

    return (
        <div className="box-content-parent">
            <Link to={boxDetails.link}>
                <div className="box-content-top">
                    <div>
                        {boxDetails.icon}
                    </div>
                    <div>
                        <h3>{boxDetails.heading}</h3>
                        <p>{boxDetails.content}</p>
                    </div>

                </div>
                
            </Link>
            {boxDetails.notifStatic && (<>{boxDetails.notifStatic}</>)}
            {boxDetails.notif &&
                <PopupNotif notif={boxDetails.notif}/>
            }
        </div>
    )
}